module.exports = __webpack_public_path__ + "img/calculator.718c95c4.svg";